/**
 * @desc 下拉筛选框
 * @param queryList?: {
    label: string, // 搜索项文字
    key: string | number, // 搜索项 key 值
  }[]
 * @param onChange?: (val: any, option: any) => void;  返回val：`${搜索项key值}_${搜索内容}`
 * */
import React from 'react';
import { Select, Icon } from 'antd';
import style from './style.less';
class SelectQuery extends React.Component {
    constructor(props) {
        super(props);
        this.lastFetchId = 0;
        this.state = {
            value: undefined,
            query: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.triggerChange = this.triggerChange.bind(this);
        this.changeQuery = this.changeQuery.bind(this);
    }
    static getDerivedStateFromProps(props) {
        return props.hasOwnProperty('value') ? {
            value: props.value,
        } : null;
    }
    triggerChange(changedValue, option) {
        const onChange = this.props.onChange;
        if (onChange) {
            onChange(changedValue, option);
        }
    }
    handleChange(value, option) {
        this.setState({
            value,
        });
        this.triggerChange(value, option);
    }
    changeQuery(val) {
        this.setState({
            query: val,
        });
    }
    render() {
        const { value, query } = this.state;
        const { placeholder, queryList } = this.props;
        let placeholderStr = placeholder;
        if (!placeholderStr) {
            const holderList = queryList.map((item) => item.label);
            placeholderStr = holderList.join('/');
        }
        return (<>
        <div className={style.icon}>
          {!value ? <Icon type="search"/> : <Icon type="close-circle" theme="filled" onClick={() => {
            this.changeQuery('');
            this.handleChange(undefined, {});
        }}/>}
        </div>
        <Select allowClear={false} showSearch value={value} placeholder={placeholderStr} filterOption={false} onSearch={this.changeQuery} onSelect={this.handleChange} notFoundContent={null} style={{ width: '100%' }} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} suffixIcon={(<span />)}>
          {query && queryList.map((item) => {
            return (<Select.Option title={query} value={`${item.key}_${query}`} key={`${item.key}_${query}`} className={style.test}>
                  <span>{query}</span>
                  <div style={{ display: 'none' }}>
                    在 {item.label} 中查询『{query}』
                  </div>
                </Select.Option>);
        })}
        </Select>
      </>);
    }
}
SelectQuery.defaultProps = {
    queryList: [],
};
export default SelectQuery;
